import { render } from "./OverallBalanceCard.vue?vue&type=template&id=7be1fd4e"
import script from "./OverallBalanceCard.vue?vue&type=script&lang=js"
export * from "./OverallBalanceCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__